import { ZscalerIconUrl } from "@p0security/shared/integrations/constants";
import { ZpaComponents } from "@p0security/shared/integrations/resources/zpa/components";
import { Install, InstallProps } from "components/Integrations/Install/Install";
import { zpaInstaller } from "components/Integrations/Zpa/install/install";
import { useCallback } from "react";

export const Zpa = (
  props: Pick<InstallProps<typeof ZpaComponents>, "cardOverride" | "onInstall">
) => {
  const itemKind = useCallback(() => "customer", []);
  const identifier = useCallback(() => "name", []);

  return (
    <Install<typeof ZpaComponents>
      components={ZpaComponents}
      installer={zpaInstaller}
      integration="zscaler-private-access"
      itemKind={itemKind}
      identifier={identifier}
      logo={ZscalerIconUrl}
      title="Zscaler Private Access"
      {...props}
    />
  );
};
